import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { ChatStateService } from '../services/chat-state.service';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule],
  template: `<p>Processing login...</p>`,
})
export class CallbackComponent implements OnInit {
  private auth = inject(AuthService);
  private chatState = inject(ChatStateService);
  private router = inject(Router);

  async ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) {
      console.error('No code in callback');
      return;
    }
    try {
      const tokenResp = await this.auth.processCallback(code);
      this.chatState.token.set(tokenResp.id_token);
      localStorage.setItem('access-token', tokenResp.id_token);
      await this.router.navigate(['/messaging']);
    } catch (err) {
      console.error('Callback processing failed:', err);
    }

  }
}
